import React, { useState } from 'react';
import UserManagement from './UserManagement';
import ChangePassword from './ChangePassword';
import ContactMessages from './ContactMessages';
import ProductManagement from './ProductManagement';
import EventManagement from './EventManagement';
import ExhibitionManagement from './ExhibitionManagement';
import FilmManagement from './FilmManagement';
import StoriesSettings from './StoriesSettings';
import AboutUsSettings from './AboutUsSettings';
import TeamMembersManagement from './TeamMembersManagement';
import Analytics from './Analytics';
import Dashboard from './Dashboard';
import FAQManagement from './FAQManagement';
import SparePartsManagement from './SparePartsManagement';
import ContactInfo from './ContactInfo';
import SubscriptionManagement from './SubscriptionManagement';
import SiteSettings from './SiteSettings';
import metalboxLogo from '../assets/logo/metalbox-logo.png';

const AdminDashboard = ({ onLogout }) => {
  const [currentPage, setCurrentPage] = useState('dashboard');

  const handleLogout = () => {
    onLogout();
  };

  return (
    <div className="flex min-h-screen bg-[#0a0c0a]">
      {/* 左侧边栏 */}
      <aside className="w-64 bg-[#12140f] border-r border-[#2a2d27] flex flex-col">
        {/* Logo */}
        <div className="p-6 border-b border-[#2a2d27]">
          <div
            className="flex items-center gap-3 cursor-pointer group"
            onClick={() => setCurrentPage('dashboard')}
          >
            {/* Metalbox Logo */}
            <div className="w-12 h-12 rounded-lg overflow-hidden bg-white flex items-center justify-center group-hover:shadow-xl group-hover:scale-105 transition-all duration-300">
              <img
                src={metalboxLogo}
                alt="Metalbox Logo"
                className="w-full h-full object-contain p-1 group-hover:scale-110 transition-transform duration-300"
              />
            </div>
            <div>
              <h2 className="text-white font-bold text-lg group-hover:text-[#f5a623] transition-colors">
                METALBOX
              </h2>
              <p className="text-[#f5a623] text-xs">管理系统</p>
            </div>
          </div>
        </div>

        {/* 导航菜单 */}
        <nav className="flex-1 p-4">
          <button
            onClick={() => setCurrentPage('dashboard')}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${currentPage === 'dashboard'
              ? 'bg-[#1a1d17] text-white'
              : 'text-gray-400 hover:bg-[#1a1d17] hover:text-white'
              }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              viewBox="0 0 256 256"
            >
              <path d="M216,115.54V208a8,8,0,0,1-8,8H160a8,8,0,0,1-8-8V160a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v48a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V115.54a8,8,0,0,1,2.62-5.92l80-75.54a8,8,0,0,1,10.77,0l80,75.54A8,8,0,0,1,216,115.54Z"></path>
            </svg>
            <span className="font-medium">仪表板</span>
          </button>

          <button
            onClick={() => setCurrentPage('messages')}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${currentPage === 'messages'
              ? 'bg-[#1a1d17] text-[#f5a623]'
              : 'text-gray-400 hover:bg-[#1a1d17] hover:text-white'
              }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              viewBox="0 0 256 256"
            >
              <path d="M216,48H40A16,16,0,0,0,24,64V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V64A16,16,0,0,0,216,48Zm-8,144H48V80h160ZM190.06,90.06a8,8,0,0,1,0,11.31L130.37,161a8,8,0,0,1-11.31,0l-48-48a8,8,0,0,1,11.31-11.31L128,144.63l53.65-53.65A8,8,0,0,1,190.06,90.06Z"></path>
            </svg>
            <span className="font-medium">联系消息</span>
          </button>

          <button
            onClick={() => setCurrentPage('products')}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${currentPage === 'products'
              ? 'bg-[#1a1d17] text-[#f5a623]'
              : 'text-gray-400 hover:bg-[#1a1d17] hover:text-white'
              }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              viewBox="0 0 256 256"
            >
              <path d="M216,64H176V56a48,48,0,0,0-96,0v8H40A16,16,0,0,0,24,80V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V80A16,16,0,0,0,216,64ZM96,56a32,32,0,0,1,64,0v8H96Zm120,144H40V80H216V200Z"></path>
            </svg>
            <span className="font-medium">产品管理</span>
          </button>

          <button
            onClick={() => setCurrentPage('events')}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${currentPage === 'events'
              ? 'bg-[#1a1d17] text-[#f5a623]'
              : 'text-gray-400 hover:bg-[#1a1d17] hover:text-white'
              }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              viewBox="0 0 256 256"
            >
              <path d="M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Z"></path>
            </svg>
            <span className="font-medium">活动管理</span>
          </button>

          <button
            onClick={() => setCurrentPage('exhibitions')}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${currentPage === 'exhibitions'
              ? 'bg-[#1a1d17] text-[#f5a623]'
              : 'text-gray-400 hover:bg-[#1a1d17] hover:text-white'
              }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              viewBox="0 0 256 256"
            >
              <path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,16V158.75l-26.07-26.06a16,16,0,0,0-22.63,0l-20,20-44-44a16,16,0,0,0-22.62,0L40,149.37V56ZM40,172l52-52,80,80H40Zm176,28H194.63l-36-36,20-20L216,181.38V200ZM144,100a12,12,0,1,1,12,12A12,12,0,0,1,144,100Z"></path>
            </svg>
            <span className="font-medium">参展信息</span>
          </button>

          <button
            onClick={() => setCurrentPage('films')}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${currentPage === 'films'
              ? 'bg-[#1a1d17] text-[#f5a623]'
              : 'text-gray-400 hover:bg-[#1a1d17] hover:text-white'
              }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              viewBox="0 0 256 256"
            >
              <path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM40,56H80V80H40ZM80,96v24H40V96Zm16,24V96h64v24Zm64-40V56h16V80Zm32,0V56h24V80Zm24,16v24H192V96ZM160,200V176h56v24Zm56-40H192V136h24ZM40,200V176H80v24Zm56,0V176h64v24Zm0-40V136h64v24Zm-16,0H40V136H80Zm16-40V96h64v24Z"></path>
            </svg>
            <span className="font-medium">影视剧合作</span>
          </button>

          <button
            onClick={() => setCurrentPage('stories-settings')}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${currentPage === 'stories-settings'
              ? 'bg-[#1a1d17] text-[#f5a623]'
              : 'text-gray-400 hover:bg-[#1a1d17] hover:text-white'
              }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              viewBox="0 0 256 256"
            >
              <path d="M208,24H72A32,32,0,0,0,40,56V224a8,8,0,0,0,8,8H192a8,8,0,0,0,0-16H56a16,16,0,0,1,16-16H208a8,8,0,0,0,8-8V32A8,8,0,0,0,208,24Zm-8,160H72a31.82,31.82,0,0,0-16,4.29V56A16,16,0,0,1,72,40H200Z"></path>
            </svg>
            <span className="font-medium">Stories设置</span>
          </button>

          <button
            onClick={() => setCurrentPage('about-us-settings')}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${currentPage === 'about-us-settings'
              ? 'bg-[#1a1d17] text-[#f5a623]'
              : 'text-gray-400 hover:bg-[#1a1d17] hover:text-white'
              }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              viewBox="0 0 256 256"
            >
              <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176Zm-20-80a12,12,0,1,1,12,12A12,12,0,0,1,124,96Z"></path>
            </svg>
            <span className="font-medium">About Us设置</span>
          </button>

          <button
            onClick={() => setCurrentPage('team-members')}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${currentPage === 'team-members'
              ? 'bg-[#1a1d17] text-[#f5a623]'
              : 'text-gray-400 hover:bg-[#1a1d17] hover:text-white'
              }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              viewBox="0 0 256 256"
            >
              <path d="M117.25,157.92a60,60,0,1,0-66.5,0A95.83,95.83,0,0,0,3.53,195.63a8,8,0,1,0,13.4,8.74,80,80,0,0,1,134.14,0,8,8,0,0,0,13.4-8.74A95.83,95.83,0,0,0,117.25,157.92ZM40,108a44,44,0,1,1,44,44A44.05,44.05,0,0,1,40,108Zm210.14,96.37a8,8,0,0,1-13.4-8.74,79.9,79.9,0,0,0-35.12-33.53,96.09,96.09,0,0,0-34.37-60.4,8,8,0,0,1,10.22-12.58,111.9,111.9,0,0,1,40.06,70.38,95.91,95.91,0,0,1,32.61,44.87ZM184,88a44,44,0,1,1-44-44A44.05,44.05,0,0,1,184,88Z"></path>
            </svg>
            <span className="font-medium">团队管理</span>
          </button>

          <button
            onClick={() => setCurrentPage('analytics')}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${currentPage === 'analytics'
              ? 'bg-[#1a1d17] text-[#f5a623]'
              : 'text-gray-400 hover:bg-[#1a1d17] hover:text-white'
              }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              viewBox="0 0 256 256"
            >
              <path d="M224,200h-8V40a8,8,0,0,0-8-8H152a8,8,0,0,0-8,8V80H96a8,8,0,0,0-8,8v40H40a8,8,0,0,0-8,8v64H24a8,8,0,0,0,0,16H224a8,8,0,0,0,0-16ZM160,48h40V200H160ZM104,96h40V200H104ZM48,144H88v56H48Z"></path>
            </svg>
            <span className="font-medium">访问统计</span>
          </button>

          <button
            onClick={() => setCurrentPage('faqs')}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${currentPage === 'faqs'
              ? 'bg-[#1a1d17] text-[#f5a623]'
              : 'text-gray-400 hover:bg-[#1a1d17] hover:text-white'
              }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              viewBox="0 0 256 256"
            >
              <path d="M140,180a12,12,0,1,1-12-12A12,12,0,0,1,140,180ZM128,72c-22.06,0-40,16.15-40,36v4a8,8,0,0,0,16,0v-4c0-11,10.77-20,24-20s24,9,24,20-10.77,20-24,20a8,8,0,0,0-8,8v8a8,8,0,0,0,16,0v-.72c18.24-3.35,32-17.9,32-35.28C168,88.15,150.06,72,128,72Zm104,56A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"></path>
            </svg>
            <span className="font-medium">FAQ管理</span>
          </button>

          <button
            onClick={() => setCurrentPage('spare-parts')}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${currentPage === 'spare-parts'
              ? 'bg-[#1a1d17] text-[#f5a623]'
              : 'text-gray-400 hover:bg-[#1a1d17] hover:text-white'
              }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              viewBox="0 0 256 256"
            >
              <path d="M128,80a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Zm109.94-52.79a8,8,0,0,0-3.89-5.4l-29.83-17-.12-33.62a8,8,0,0,0-2.83-6.08,111.91,111.91,0,0,0-36.72-20.67,8,8,0,0,0-6.46.59L128,41.85,97.88,25a8,8,0,0,0-6.47-.6A111.92,111.92,0,0,0,54.73,45.15a8,8,0,0,0-2.83,6.07l-.15,33.65-29.83,17a8,8,0,0,0-3.89,5.4,106.47,106.47,0,0,0,0,41.56,8,8,0,0,0,3.89,5.4l29.83,17,.12,33.63a8,8,0,0,0,2.83,6.08,111.91,111.91,0,0,0,36.72,20.67,8,8,0,0,0,6.46-.59L128,214.15,158.12,231a7.91,7.91,0,0,0,3.9,1,8.09,8.09,0,0,0,2.57-.42,112.1,112.1,0,0,0,36.68-20.73,8,8,0,0,0,2.83-6.07l.15-33.65,29.83-17a8,8,0,0,0,3.89-5.4A106.47,106.47,0,0,0,237.94,107.21Zm-15,34.91-28.57,16.25a8,8,0,0,0-3.89,5.4,106.47,106.47,0,0,1,0,41.56,8,8,0,0,0,3.89,5.4l28.57,16.25a96.43,96.43,0,0,1-30.27,17.59L165.54,226a8,8,0,0,0-6.47-.6,111.91,111.91,0,0,1-36.72,20.67,8,8,0,0,0-6.46.59L90.46,230a96.43,96.43,0,0,1-30.27-17.59l28.57-16.25a8,8,0,0,0,3.89-5.4,106.47,106.47,0,0,1,0-41.56,8,8,0,0,0-3.89-5.4L60.19,127.54A96.43,96.43,0,0,1,90.46,110l28.57,16.25a8,8,0,0,0,6.47.6,111.91,111.91,0,0,1,36.72-20.67,8,8,0,0,0,6.46-.59L195.81,88.46A96.43,96.43,0,0,1,226.08,106Z"></path>
            </svg>
            <span className="font-medium">零件支持</span>
          </button>

          <button
            onClick={() => setCurrentPage('contact-info')}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${currentPage === 'contact-info'
              ? 'bg-[#1a1d17] text-[#f5a623]'
              : 'text-gray-400 hover:bg-[#1a1d17] hover:text-white'
              }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              viewBox="0 0 256 256"
            >
              <path d="M128,64a40,40,0,1,0,40,40A40,40,0,0,0,128,64Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,128,128Zm0-112a88.1,88.1,0,0,0-88,88c0,31.4,14.51,64.68,42,96.25a254.19,254.19,0,0,0,41.45,38.3,8,8,0,0,0,9.18,0A254.19,254.19,0,0,0,174,200.25c27.45-31.57,42-64.85,42-96.25A88.1,88.1,0,0,0,128,16Zm0,206c-16.53-13-72-60.75-72-118a72,72,0,0,1,144,0C200,161.23,144.53,209,128,222Z"></path>
            </svg>
            <span className="font-medium">联系信息</span>
          </button>

          <button
            onClick={() => setCurrentPage('subscriptions')}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${currentPage === 'subscriptions'
              ? 'bg-[#1a1d17] text-[#f5a623]'
              : 'text-gray-400 hover:bg-[#1a1d17] hover:text-white'
              }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              viewBox="0 0 256 256"
            >
              <path d="M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48ZM203.43,64,128,133.15,52.57,64ZM216,192H40V74.19l82.59,75.71a8,8,0,0,0,10.82,0L216,74.19V192Z"></path>
            </svg>
            <span className="font-medium">订阅管理</span>
          </button>

          <button
            onClick={() => setCurrentPage('users')}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${currentPage === 'users'
              ? 'bg-[#1a1d17] text-white'
              : 'text-gray-400 hover:bg-[#1a1d17] hover:text-white'
              }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              viewBox="0 0 256 256"
            >
              <path d="M117.25,157.92a60,60,0,1,0-66.5,0A95.83,95.83,0,0,0,3.53,195.63a8,8,0,1,0,13.4,8.74,80,80,0,0,1,134.14,0,8,8,0,0,0,13.4-8.74A95.83,95.83,0,0,0,117.25,157.92ZM40,108a44,44,0,1,1,44,44A44.05,44.05,0,0,1,40,108Z"></path>
            </svg>
            <span className="font-medium">用户管理</span>
          </button>

          <button
            onClick={() => setCurrentPage('settings')}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${currentPage === 'settings'
              ? 'bg-[#1a1d17] text-white'
              : 'text-gray-400 hover:bg-[#1a1d17] hover:text-white'
              }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              viewBox="0 0 256 256"
            >
              <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm0-160a72,72,0,1,0,72,72A72.08,72.08,0,0,0,128,56Zm0,128a56,56,0,1,1,56-56A56.06,56.06,0,0,1,128,184Z"></path>
            </svg>
            <span className="font-medium">网站设置</span>
          </button>

          <button
            onClick={() => setCurrentPage('change-password')}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${currentPage === 'change-password'
              ? 'bg-[#1a1d17] text-white'
              : 'text-gray-400 hover:bg-[#1a1d17] hover:text-white'
              }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              viewBox="0 0 256 256"
            >
              <path d="M128,16A112,112,0,1,0,240,128,112.13,112.13,0,0,0,128,16Zm0,216a104,104,0,1,1,104-104A104.11,104.11,0,0,1,128,232Zm36.55-116.4-12.78-1.6a44,44,0,0,0-87.54,0l-12.78,1.6A20,20,0,0,0,20,120v56a20,20,0,0,0,20,20h176a20,20,0,0,0,20-20V120A20,20,0,0,0,164.55,115.6ZM216,176a12,12,0,0,1-12,12H52a12,12,0,0,1-12-12V120a12,12,0,0,1,13.46-11.92l12.78,1.6A52,52,0,0,0,189.76,108.68l12.78-1.6A12,12,0,0,1,216,120Z"></path>
            </svg>
            <span className="font-medium">修改密码</span>
          </button>
        </nav>

        {/* 修改密码和登出按钮 */}
        <div className="p-4 border-t border-[#2a2d27] space-y-2">
          <button
            onClick={handleLogout}
            className="w-full px-4 py-3 bg-red-600/20 hover:bg-red-600/30 text-red-400 hover:text-red-300 rounded-lg font-medium transition-colors text-sm flex items-center justify-center gap-2"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              fill="currentColor"
              viewBox="0 0 256 256"
            >
              <path d="M112,216a8,8,0,0,1-8,8H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32h56a8,8,0,0,1,0,16H48V208h56A8,8,0,0,1,112,216Zm106.06-98.06-24-24a8,8,0,0,0-11.31,11.31L187.63,120H120a8,8,0,0,0,0,16h67.63l-24.88,24.88a8,8,0,0,0,11.31,11.31l24-24A8,8,0,0,0,218.06,117.94Z"></path>
            </svg>
            登出
          </button>
        </div>
      </aside>

      {/* 主内容区域 */}
      <main className="flex-1 flex flex-col">
        {/* 顶部栏 */}
        <header className="bg-[#12140f] border-b border-[#2a2d27] px-8 py-4 flex items-center justify-between">
          <h1 className="text-white text-2xl font-bold">
            {currentPage === 'dashboard' && '仪表板'}
            {currentPage === 'messages' && '联系消息'}
            {currentPage === 'products' && '产品管理'}
            {currentPage === 'events' && '活动管理'}
            {currentPage === 'exhibitions' && '参展信息管理'}
            {currentPage === 'films' && '影视剧合作管理'}
            {currentPage === 'stories-settings' && 'Stories设置'}
            {currentPage === 'about-us-settings' && 'About Us设置'}
            {currentPage === 'team-members' && '团队管理'}
            {currentPage === 'analytics' && '访问统计'}
            {currentPage === 'faqs' && 'FAQ管理'}
            {currentPage === 'spare-parts' && '零件支持管理'}
            {currentPage === 'contact-info' && '联系信息管理'}
            {currentPage === 'subscriptions' && '订阅管理'}
            {currentPage === 'users' && '用户管理'}
            {currentPage === 'settings' && '网站设置'}
            {currentPage === 'change-password' && '修改密码'}
          </h1>
        </header>

        {/* 内容区域 */}
        <div className="flex-1 overflow-auto p-8">
          {currentPage === 'dashboard' && <Dashboard />}

          {currentPage === 'messages' && <ContactMessages />}

          {currentPage === 'products' && <ProductManagement />}
          {currentPage === 'events' && <EventManagement />}
          {currentPage === 'exhibitions' && <ExhibitionManagement />}
          {currentPage === 'films' && <FilmManagement />}
          {currentPage === 'stories-settings' && <StoriesSettings />}
          {currentPage === 'about-us-settings' && <AboutUsSettings />}
          {currentPage === 'team-members' && <TeamMembersManagement />}
          {currentPage === 'analytics' && <Analytics />}
          {currentPage === 'faqs' && <FAQManagement />}
          {currentPage === 'spare-parts' && <SparePartsManagement />}
          {currentPage === 'contact-info' && <ContactInfo />}
          {currentPage === 'subscriptions' && <SubscriptionManagement />}

          {currentPage === 'users' && <UserManagement />}
          {currentPage === 'settings' && <SiteSettings />}

          {currentPage === 'change-password' && <ChangePassword />}
        </div>
      </main>
    </div>
  );
};

export default AdminDashboard;
